
import { Component, Mixins, Watch } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { CLIENT, CACHE_STRATEGY } from '@/constants';
import { CLoader } from '@/components/loader'
import { CButton } from '@/components/form-controls/button'
import { PreloadService, LanguagesService } from '@/@next/services'
import CModal from '@/components/modal'
import { Language } from '@/@types/graphql'
import { messages } from '@/@next/i18n'
import { SvgIcon, IconDownload, IconCheck} from '@/@next/components/icons'
import { DataToPreloadStrategy, PreloadConsentStatus, PreloadingDataStatus } from '@/@next/store/app'

const config = {
  name: 'l-default-cache-preloader',
  i18n: { messages },
  components: {
    CLoader,
    CButton,
    ...CModal,
    SvgIcon,
    IconDownload,
    IconCheck
  }
}

@Component(config)
export default class LDefaultCachePreloader extends Mixins(PreloadService, LanguagesService) {

  isOpen: boolean = true
  showConsent: boolean = false
  // showPreloadModal: boolean = false
  showReloadModal: boolean = false
  willReload: boolean = false;

  async mounted () {
    console.info(`[Info][CachePreloader] Cache stratery for project ${CLIENT} : ${CACHE_STRATEGY}`)
    // Vérification de demande d'un comportement custom du preload
    this.getPreloadUrlQuery()
    this.getPreloadInReactNativeContext()
    // Récupérations des données à précharger ainsi que la UI configuration à appliquer
    await this.fetchPreloadData()
    // Rechargement de l'application si necessaire (ex: nouvelle version de l'application)
    this.onNeedToReloadAppUpdate()
  }

  @Watch('preloadConfiguration')
  @Watch('appIsReady')
  @Watch('serviceWorkerIsReady')
  onCachePreloaderConfigUpdate () {
    console.log(`[temp] onCachePreloaderStateUpdate. 
      (preloadConfiguration: ${this.preloadConfiguration},
      appIsReady: ${this.appIsReady},
      preloadIsEnabled: ${this.preloadIsEnabled})`)
    if (!this.appIsReady || !this.preloadIsEnabled) return
    if (!this.serviceWorkerIsReady) return this.tryToReload()
    console.log(`[TEMP] Service Worker is ready ?: ${this.serviceWorkerIsReady}`)
    console.log('[TEMP] onCachePreloaderStateUpdate preloadStrategy :', this.preloadStrategy)
    if (!this.preloadConfiguration) return 
    console.log('[TEMP] onCachePreloaderStateUpdate preloadConfiguration :', this.preloadConfiguration)
    // block reloading function
    this.willReload = false
    this.checkUserConsent()
    console.log('[TEMP] startPreloadingData..... ')
    this.setPreloadIsReady(true)
    setTimeout(() => {
      this.startPreload()
    }, this.preloadConfiguration?.startPreloadTimeout || 2000)
  }

  @Watch('needToReloadApp')
  onNeedToReloadAppUpdate () {
    if (this.needToReloadApp) this.showReloadModal = true
  }

  startPreload () {
    // Si aucune ressources à preload => pas de prelaod
    if (!this.hasPreloadRessources && !this.hasPreloadFiles) return
    // Verrification si les notification ne sont pas désactivée
    if (!this.preloadConfiguration?.disableNotification) this.setShowPreloadTopBarButton(true)
    // Affichage de la modal de preload si l'autorisation de preload est inconnnue et si les notifications autorisées.
    if (this.hasUnknownPreload && !this.preloadConfiguration?.disableNotification ) this.setShowPreloadModal(true)
    // Start preload if consent exist
    if (this.hasAcceptPreload) this.startPreloadingData()
  }

  onConsentPreloadHandler () {
    this.acceptPreload()
    this.startPreloadingData()
  }

  onRejectPreloadHandler () {
    this.rejectPreload()
    this.setShowPreloadModal(false)
  }

  onClosePreloadModal () {
    this.setShowPreloadModal(false)
  }

  getPreloadUrlQuery () {
    try {
      const { preload, ...queries } = this.$route.query
      console.log('[TEMP] getPreloadUrlQuery ', preload)
      if (preload) {
        // Remove preload query from router history
        // this.$router.replace({ query: queries })
        const preloadStrategy = preload.length && preload as DataToPreloadStrategy
        if (preloadStrategy && preloadStrategy in DataToPreloadStrategy) {
          this.setPreloadStrategy(preloadStrategy)
        }  
      }
    } catch (e) {
      console.error(`Error during getPreloadUrlQuery ${e}`)
      return false
    }
  }

  getPreloadInReactNativeContext () {
    try {
      // @ts-ignore
      if (window.ReactNativeWebView) {
        console.log('[TEMP][PRELOAD] Is react Native WebView, set force preload')
        this.setPreloadStrategy(DataToPreloadStrategy.reactNativeWebView)
      }
      // this.setPreloadStrategy(DataToPreloadStrategy.reactNativeWebView)
    } catch (e) {
      console.error(`Error during getPreloadInReactNativeContext ${e}`)
    }
  }

  tryToReload () {
    // A Revoir
    console.info('[Info][CachePreloader] Reloading app')
    console.log('SAFARI ? ', this.isSafari)
    if (this.willReload) return

    // To Do test Firefox
    // if (this.isSafari) {
    console.log('[temp] Safari reload')
    this.willReload = true;
    // this.showReloadModal = true;
    setTimeout(() => this.showReloadModal = true, 2000) 

  }

  cancelReload () {
    this.showReloadModal = false;
    this.willReload = false;
    this.setNeedToReloadApp(false)
  }

  accepReload () {
    this.showReloadModal = false
    this.setNeedToReloadApp(false)
    setTimeout(() => location.reload(), 1000)
  }

  reloadApp () {
      console.log('[temp] in reloading app function')
      if (!this.willReload) return
      location.reload()
  }

  get isSafari () {
      const ua = navigator.userAgent.toLowerCase(); 
      let isSafari = false;
      try {
          // @ts-ignore
          isSafari = /constructor/i.test(window.HTMLElement) || ((p: any) => p.toString() === '[object SafariRemoteNotification]')(!window.safari || safari.pushNotification);
      } catch (err) { console.error(err)}
      isSafari = (isSafari || ((ua.indexOf('safari') !== -1)
          && (!(ua.indexOf('chrome') !== -1) && (ua.indexOf('version/') !== -1))));
      return isSafari
  }

  get forcePreload () {
    return this.preloadConfiguration?.forcePreload
  }

  get blockUser () {
    return  this.showPreloadModal || (this.forcePreload && this.consentPreload && !this.preloadEnded)
  }

  get CSSClasses () {
    return {
      'is-Open': this.showPreloadModal,
      'overlay': this.showPreloadModal && !this.consentPreload
    }
  }

  get currentLanguageName () {
    const language = this._allLanguages.find((l: Language) => l.iso === this._currentLanguage)
    if (!language) return this._currentLanguage.toLowerCase()
    return language.name?.toLowerCase() || this._defaultLanguage.toLowerCase()
  }

  get unstarted () {
    return this.preloadRessourceStatus === PreloadingDataStatus.unstarted 
      && this.preloadFileStatus === PreloadingDataStatus.unstarted
  }

  get hasPreloadRessources () {
    // if (!this.dataToPreload?.resources) return false
    return this.dataToPreload?.resources?.length
  } 

  get hasPreloadFiles () {
    return this.dataToPreload?.files?.length
  } 

  get hasPreloadImageFile () {
    return this.dataToPreload?.files?.find((f: any) => f.mediaType === 'Image' ) || false
  }

  get hasPreloadAudioFile () {
    return this.dataToPreload?.files?.find((f: any) => f.mediaType === 'Audio' ) || false
  }

  get ressourceLoading () {
    return this.preloadRessourceStatus === PreloadingDataStatus.loading 
  } 

  get fileLoading () {
    return this.preloadFileStatus === PreloadingDataStatus.loading 
  } 

  get loading () {
    return this.ressourceLoading || this.fileLoading
  }

  get ressourceSuccess () {
    return this.preloadRessourceStatus === PreloadingDataStatus.complete 
  } 

  get ressourceError () {
    return this.preloadRessourceStatus === PreloadingDataStatus.error
    || this.preloadRessourceStatus === PreloadingDataStatus.uncomplete
  } 

  get fileSuccess () {
    return this.preloadFileStatus === PreloadingDataStatus.complete 
  } 

  get fileError () {
    return this.preloadFileStatus === PreloadingDataStatus.error
    || this.preloadFileStatus === PreloadingDataStatus.uncomplete
  } 

  get hasAcceptPreload () {
    return this.consentPreload === PreloadConsentStatus.accepted
  }

  get hasRejectPreload () {
    return this.consentPreload === PreloadConsentStatus.rejected
  }

  get hasUnknownPreload () {
    return this.consentPreload === PreloadConsentStatus.unknown
  }

}
